module.exports = __webpack_public_path__ + "img/11.38dac0a5.jpg";